import React from 'react';
import { Text } from '@rneui/themed';
import { Row } from '../../elements';
import { useSleepTimer } from '../../../hooks/player';
import { useTheme } from '../../../hooks';
export const Timer = ({ style = {}, }) => {
    const { colors } = useTheme();
    const { hrs, mins, secs, } = useSleepTimer();
    return (React.createElement(Row, { style: style },
        React.createElement(Text, { style: { color: colors.accent } },
            hrs < 10 ? '0' : '',
            hrs,
            ":",
            mins < 10 ? '0' : '',
            mins,
            ":",
            secs < 10 ? '0' : '',
            secs)));
};
//# sourceMappingURL=Timer.js.map